import React from "react"

const FilterSection = ({ title, children }) => {
  return (
    <div className="py-4 border-b border-[#E7EAEF] last:border-b-0">
      <h4 className="text-[11px] uppercase tracking-wide text-[#9AA5B4] font-medium mb-2">
        {title}
      </h4>
      {children}
    </div>
  )
}

export default FilterSection
